import React from "react";
import { Backdrop } from "@material-ui/core";
import './styles.scss';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const BackdropElement = (props) => {
  const { loader = true, handleClose } = props;
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={true} onClick={handleClose}>
      {loader && <div className="preloader"><div/><div/><div/><div/><div/><div/><div/><div/><div/><div/></div>}
    </Backdrop>
  );
};

export default BackdropElement;
